// extracted by mini-css-extract-plugin
export default {"main":"PetsPage_main__y2TBd"};